import type { FaireProductEntity } from "../../entity_types/product";

export const p_nmegdvfgpt: FaireProductEntity = {
  token: "p_nmegdvfgpt",
  type: "product",
  name: "Please Be Patient With me Funny Signs With Sayings",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/6a80db80b36529e72a1c0ee1883cef62ea30009cf78eb705abd3aa08e3a385f3.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/92d772461b621d46b78bd7b902229ec5ea327f5abc53ba459e2b6a406e3ae1ea.jpeg",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
